import Color from 'color'

/**
 * Updates the opacity of a given color.
 */
export function updateColorOpacity(color: string, opacity: number): string {
  const colorObj = Color(color)
  return colorObj.alpha(opacity).rgb().string()
}

/**
 * Converts a color string to an RGB string.
 *
 * NOTE: This function **only** outputs the RGB values, not RGBA.
 * This is useful for libraries like Three.js, which only accept rgb,
 * and will send console.warns if an alpha value is supplied
 */
export function colorAsRGBString(color: string): string {
  const rgbObj = Color(color).rgb().object()
  return `rgb(${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b})`
}

/**
 * Generates the css-string for a striped color (which can be used with the `background` property).
 */
export function generateStripedColorCSS(
  color1: string,
  color2: string,
  spacing: string,
  rotation: string
): string {
  return `repeating-linear-gradient(
    ${rotation},
    ${color1},
    ${color1} ${spacing},
    ${color2} ${spacing},
    ${color2} calc(${spacing} * 2)
  )`
}

/**
 * Generates the css-string for a checkerboard color (which can be used with the `background` property).
 */
export function generateCheckerboardColorCSS(
  color1: string,
  color2: string,
  checkerSideLength: string
): string {
  return `repeating-conic-gradient(${color1} 0% 25%, ${color2} 0% 50%) 
      50% / ${checkerSideLength} ${checkerSideLength}`
}
